import { render, staticRenderFns } from "./TableLinkCell.vue?vue&type=template&id=13ef8b4a&scoped=true"
import script from "./TableLinkCell.vue?vue&type=script&lang=js"
export * from "./TableLinkCell.vue?vue&type=script&lang=js"
import style0 from "./TableLinkCell.vue?vue&type=style&index=0&id=13ef8b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef8b4a",
  null
  
)

export default component.exports